import { api } from "@/redux/api";

import {
	DashboardResponse,
	DashboardResponseSchema,
	DismissIssueRequest,
} from "@/pages/Private/pages/Dashboard/schema/dashboard";

export const dashboardApi = api.injectEndpoints({
	endpoints: (builder) => ({
		getDashboard: builder.query<DashboardResponse, void>({
			query: () => ({
				url: "list/dashboard",
				responseSchema: DashboardResponseSchema,
			}),
			providesTags: ["Dashboard"],
		}),
		dismissDashboardIssue: builder.mutation<unknown, DismissIssueRequest>({
			query: ({ type, entityId }) => ({
				url: `list/dashboard/issues/${type}/dismiss`,
				method: "POST",
				body: entityId !== undefined && entityId !== null ? { entityId } : {},
			}),
			invalidatesTags: ["Dashboard"],
		}),
		undismissDashboardIssue: builder.mutation<unknown, DismissIssueRequest>({
			query: ({ type, entityId }) => ({
				url: `list/dashboard/issues/${type}/dismiss`,
				method: "DELETE",
				body: entityId !== undefined && entityId !== null ? { entityId } : {},
			}),
			invalidatesTags: ["Dashboard"],
		}),
	}),
});

export const {
	useGetDashboardQuery,
	useDismissDashboardIssueMutation,
	useUndismissDashboardIssueMutation,
} = dashboardApi;
